import React, { useEffect } from 'react'
import dayjs from 'dayjs';
import weekday from "dayjs/plugin/weekday"; // Import the plugin
import localeData from "dayjs/plugin/localeData"; // Import localeData plugin
import { useCurrencyConverter } from '../../context/currencyHook';
import { useCurrency } from '../../context/CurrencyContext';

dayjs.extend(localeData); // Extend dayjs with the plugin
dayjs.extend(weekday); // Extend dayjs with the plugin

function TourSummary({ amount, packageSel = {}, title = 'Tour Summary', description = '', cn = '' }) {

  const convertCurrency = useCurrencyConverter();
  const { currency } = useCurrency();

  return (
    <div>
      <div className={`text-center !text-white text-lg font-bold mt-4 ${cn}`} style={{ color: 'black', backgroundColor: '#00803e', margin: '1rem', marginTop: '2.5rem', marginBottom: '1rem' }}>
        {title}
      </div>
      <div className='text-center text-lg'>
        {description}
      </div>
      {/*  */}
      <div className="bg-white p-6 rounded-lg shadow-lg text-left m-[1rem] flex justify-center">
        <table className="lg:w-[50%] lg:ml-[8rem]">
          <tbody>
            <tr>
              <td className="font-semibold py-2 pr-4">Package Name:</td>
              <td>{packageSel?.name || ''}</td>
            </tr>
            <tr>
              <td className="font-semibold py-2 pr-4">Package Duration:</td>
              <td>{packageSel?.description || ''}</td>
            </tr>
            <tr>
              <td className="font-semibold py-2 pr-4">Package Price:</td>
              <td>{convertCurrency(amount)} {currency}</td>
            </tr>
            <tr>
              <td className="font-semibold py-2 pr-4">Total:</td>
              <td>{convertCurrency(amount)} {currency}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default TourSummary